let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2F2K2")).then(() => parcelRequire('7mUQG'));